export default {
  hero: {
    badge: "Digital Solutions",
    titlePrefix: "Everything Your Business Needs",
    titleHighlight: "to Grow Online",
    subtitle: "From custom websites and branding to AI automation and strategy — we build the digital infrastructure that turns your vision into results.",
    cta: {
      book: "Book a Free Consultation",
      team: "Meet the Team"
    },
    stats: {
      services: "Services Offered",
      custom: "Custom Solutions",
      support: "Support & Hosting"
    }
  },
  detail: {
    common: {
      forWho: "Who it's for:",
      book: "Book a Consultation"
    },
    featured: {
      badge: "Featured Service",
      mostPopular: "Most Popular",
      title: "Website Creation + Hosting",
      desc: "Custom, modern, high-converting websites designed for businesses and entrepreneurs. Includes full website development, mobile optimization, SEO-ready structure, and hosting integration.",
      benefits: {
        b1: "Custom design tailored to your brand",
        b2: "Mobile-optimized & fully responsive",
        b3: "SEO-ready structure from day one",
        b4: "Fast performance & hosting included",
        b5: "Lead capture forms & CTA integration",
        b6: "All-in-one solution — no tech headaches"
      },
      forWho: "Business owners, entrepreneurs, and brands that want a strong, professional, and scalable online presence."
    },
    header: {
      prefix: "All Our",
      highlight: "Services",
      subtitle: "Everything you need to build, grow, and scale your business online — under one roof."
    },
    items: {
      crm: {
        title: "CRM Creation",
        desc: "Custom-built CRM systems to manage leads, clients, workflows, and internal operations efficiently.",
        benefits: {
          b1: "Better organization & client tracking",
          b2: "Automation of repetitive processes",
          b3: "Increased team productivity",
          b4: "Centralized data & reporting"
        },
        forWho: "Businesses that want to scale operations."
      },
      branding: {
        title: "Branding & Design",
        desc: "Creation of brand identity including logos, color palettes, visual direction, and marketing materials.",
        benefits: {
          b1: "Stronger brand recognition",
          b2: "Professional & consistent image",
          b3: "Logo + full brand kit",
          b4: "Marketing material templates"
        },
        forWho: "New businesses needing a refresh or stronger identity."
      },
      consulting: {
        title: "Social Media Consulting",
        desc: "Strategic guidance to help businesses grow and position themselves effectively on social media.",
        benefits: {
          b1: "Clear content strategy & direction",
          b2: "Actionable growth roadmap",
          b3: "Audience targeting insights",
          b4: "Engagement & conversion tactics"
        },
        forWho: "Owners who want to manage their own content with expert guidance."
      },
      content: {
        title: "Content Creation Consulting",
        desc: "Guidance on how to create engaging, strategic content that attracts and converts your ideal audience.",
        benefits: {
          b1: "Better content ideas & structure",
          b2: "Improved posting consistency",
          b3: "Higher engagement rates",
          b4: "Content that converts followers"
        },
        forWho: "Creators and businesses struggling with content structure."
      },
      optimization: {
        title: "Social Media Optimization",
        desc: "Optimization of social media profiles to improve clarity, branding, and conversion performance.",
        benefits: {
          b1: "More professional profiles",
          b2: "Better first impressions",
          b3: "Improved bio & link strategy",
          b4: "Higher conversion from visitors"
        },
        forWho: "Businesses with existing profiles that need improvement."
      },
      google: {
        title: "Google Business Profile",
        desc: "Setup and optimization of Google Business Profile to improve local visibility and attract more customers.",
        benefits: {
          b1: "Better local SEO ranking",
          b2: "Increased Google Maps visibility",
          b3: "More customer inquiries",
          b4: "Professional business listing"
        },
        forWho: "Local businesses wanting to appear in search & maps."
      },
      ai: {
        title: "AI Automation & Funnels",
        desc: "Creation of automated systems, funnels, and workflows using AI and digital tools that work 24/7.",
        benefits: {
          b1: "Time-saving automated workflows",
          b2: "Better lead conversion rates",
          b3: "Automated customer journeys",
          b4: "AI-powered follow-up systems"
        },
        forWho: "Businesses wanting to scale with smarter systems."
      },
      strategy: {
        title: "Consulting & Strategy",
        desc: "Personalized consulting sessions focused on business growth, digital strategy, and execution planning.",
        benefits: {
          b1: "Clear direction & expert insights",
          b2: "Actionable growth plans",
          b3: "Digital audit & gap analysis",
          b4: "Accountability & follow-through"
        },
        forWho: "Entrepreneurs ready to grow and scale."
      }
    },
    footerCta: {
      title: "Not sure which service is right for you?",
      subtitle: "Book a free strategy call and we'll help you figure out exactly what your business needs to grow.",
      book: "Get a Free Consultation"
    }
  }
};
